import {Input, Field} from "@fluentui/react-components";
import {useGlobalStatus} from '../../services/GlobalStatusProvider';

//Created custom as the inbuilt or third party time pickers were OTT or not up to standard
export default function TimePicker(props){
        const{isDesktop}= useGlobalStatus();
    
    const handleChange=(event)=> {

        var val= event.target.value.replace(/\D/g,'');

        //strictly speaking this should only happen if pasting a longer string
        if(val.length > 4 ) {
            val = val.substring(0,4);          
        }

        var ar = val.split("");
        
        if(ar.length===1){            
            if(ar[0]>2) val="";
            else val= `${ar[0]}`;
        }

        if(ar.length===2){            
            if(Number(`${ar[0]}${ar[1]}`) > 23) val=`${ar[0]}`;
            else val= `${ar[0]}${ar[1]}`
        }

        if(ar.length===3){            
            if(Number(ar[2]) > 5) val=`${ar[0]}${ar[1]}`;
            else val= `${ar[0]}${ar[1]}:${ar[2]}`
        }

        if(ar.length===4){            
            if(Number(`${ar[2]}${ar[3]}`) > 59) val=`${ar[0]}${ar[1]}:${ar[2]}`;
            else val= `${ar[0]}${ar[1]}:${ar[2]}${ar[3]}`
        }
       
        props.setValue(props.label,val);  
    }

    const handleOnBlur=(event)=> {

        var val= event.target.value.replace(/\D/g,'');
        val = val.padEnd(4, "0");

        props.setValue(val.slice(0,2) + ":" + val.slice(2));
    }

    return (
        <Field label={props.label}
            orientation="horizontal"
            required={props.required}
            validationMessage={props.validationState==="none" ? ( isDesktop &&  "") : props.validationMessage}
            validationState={props.validationState}
        >
            <Input 
                disabled={props.disabled}
                value={props.value}
                onBlur={handleOnBlur}
                placeholder={props.suggestedStart ? props.suggestedStart : "00:00"}
                onChange={handleChange} 
                style={{
                    width: '80px'
                }} 
            />
        </Field>
    )
} 